
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn/sso-aws-saml",
      function () {
        return require("private-next-pages/learn/sso-aws-saml.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learn/sso-aws-saml"])
      });
    }
  